import { Score } from "../../models/Score";

const RankProgress = ({score}:{score?: Score}) => {
	var	rank = score?.rank ?? 0
	var	maxRank = score?.maxRank ?? 0
	var progress = 0

	if (rank !== 0 && maxRank !== 0 ) {
		progress = (rank/maxRank) * 100
	}

	//Invert the progress bar
	progress = 100.0 -  progress

	return (
		<div className="col col-8 pl-0 pr-0">
			<div className="card tile w-100" style={{height: "5.0rem", justifyContent:'center'}}>
				<div className="row g-0" style={{margin: 0, padding: 0, color:'white'}}>
					<div className="col col-12 g-0 p-0" style={{ marginBottom:8, marginTop:0}}>
						Rank
					</div>
					<div className="col col-12 fw-bold fs-1 g-0 p-0"style={{marginTop:-5, marginBottom:5 , padding: 0}}>
						<div  style={{margin: "0 0.35rem 0 0.35rem" }}>
							<div className="progress" >
								<div className="progress-bar" role="progressbar" style={{width: `${progress}%`, backgroundColor:'#f69220' }} aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100}></div>
							</div>
						</div>
					</div>
					<div className="col col-12 g-0 p-0 fw-bold" style={{ marginTop:-1 }}>{rank ? `${rank} of ${maxRank}` : "No Rank"}</div>
				</div>
			</div>
		</div>
	)
}

export default RankProgress;